import { __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import ScrollableContent from '../../../ScrollableContent';
import MediaSourceMenu from '../MediaSourceMenu/Mobile';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import Breadcrumbs from '../Breadcrumbs';
import UploadButton from '../UploadButton';
import withFileUpload from '../../_hocs/withFileUpload';
import popupInnerLayoutStyles from './PopupInnerLayout.scss';
var ON_SCROLL_BOTTOM_DISTANCE = 200;
var enhance = compose(withFileUpload, withMobileContext, withCurrentGallection);
var PopupInnerLayout = /** @class */ (function (_super) {
    __extends(PopupInnerLayout, _super);
    function PopupInnerLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isHeaderSticky: false,
        };
        _this.renderMobileHeader = function () {
            var _a = _this.props, oneRowHeader = _a.oneRowHeader, headerExtrasRightZone = _a.headerExtrasRightZone, _b = _a.allowUploads, allowUploads = _b === void 0 ? true : _b, currentFolderId = _a.currentFolderId;
            return (React.createElement("div", { className: popupInnerLayoutStyles['header-top-row'] },
                oneRowHeader && _this.renderSubtitle(),
                React.createElement("div", { className: popupInnerLayoutStyles['header-bottom-row'] },
                    currentFolderId ? React.createElement(Breadcrumbs, null) : React.createElement(MediaSourceMenu, null),
                    headerExtrasRightZone),
                allowUploads && React.createElement(UploadButton, null)));
        };
        _this.renderDesktopHeader = function () {
            var _a = _this.props, oneRowHeader = _a.oneRowHeader, headerExtrasRightZone = _a.headerExtrasRightZone;
            return (React.createElement("div", { className: popupInnerLayoutStyles['header-top-row'] },
                React.createElement(Breadcrumbs, null),
                oneRowHeader && _this.renderSubtitle(),
                React.createElement("div", { className: popupInnerLayoutStyles['header-extras-right-zone'] }, headerExtrasRightZone)));
        };
        _this.renderSubtitle = function () {
            var headerSubtitle = _this.props.headerSubtitle;
            if (!headerSubtitle) {
                return null;
            }
            return (React.createElement("div", { className: popupInnerLayoutStyles['header-subtitle'] }, headerSubtitle));
        };
        _this.onScrolled = function (scrollTop, distanceToBottom) {
            var isHeaderSticky = scrollTop !== 0;
            _this.setState({ isHeaderSticky: isHeaderSticky });
            if (distanceToBottom <= ON_SCROLL_BOTTOM_DISTANCE) {
                _this.props.onScrolledToBottom && _this.props.onScrolledToBottom();
            }
        };
        return _this;
    }
    PopupInnerLayout.prototype.render = function () {
        var _a = this.props, scrollableContent = _a.scrollableContent, sideBarContent = _a.sideBarContent, onNotScrollable = _a.onNotScrollable;
        return (React.createElement(Flex, { className: popupInnerLayoutStyles['root'] },
            React.createElement(Flex, { fullWidth: true, direction: "column" },
                this.renderHeader(),
                React.createElement(ScrollableContent, { className: popupInnerLayoutStyles['scrollable-content'], onScrolled: this.onScrolled, onNotScrollable: onNotScrollable }, scrollableContent)),
            sideBarContent));
    };
    PopupInnerLayout.prototype.renderHeader = function () {
        var _a = this.props, isMobile = _a.isMobile, oneRowHeader = _a.oneRowHeader, headerExtrasBottomZone = _a.headerExtrasBottomZone;
        var isHeaderSticky = this.state.isHeaderSticky;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(popupInnerLayoutStyles['header'], isHeaderSticky && popupInnerLayoutStyles['sticky']) },
                isMobile ? this.renderMobileHeader() : this.renderDesktopHeader(),
                !oneRowHeader && this.renderSubtitle(),
                !isMobile && headerExtrasBottomZone),
            isMobile && headerExtrasBottomZone));
    };
    return PopupInnerLayout;
}(React.PureComponent));
export default enhance(PopupInnerLayout);
//# sourceMappingURL=PopupInnerLayout.connected.js.map